export default "/staticreactui/static/media/static/media/not-found-mobile.7f7b8d7b.webp";